import { gql } from '@/__generated__';

export const GATE_MESSAGE_RECEIVED = gql(`#graphql
  subscription GateMessageReceived {
    gateMessageReceived {
      id
      gateId
      movementId
      movements {
        id
        operatingState
        lastPosition
        lastBattery
        unit
        precision
        activeMovement {
          ...GateMovementFragment
        }
        lastMovement {
          ...GateMovementFragment
        }
        history {
          ...GateMovementFragment
        }
      }
      movement {
        ...GateMovementFragment
      }
      type
      state
      payload
      timestamp
    }
  }
`);
